import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "./team.module.css";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    height: 250,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 4
};

export default function BasicModal(props) {
    const axios = useAxiosPrivate()
    const { setOpen, open, group, setAlert, loadDataGroupData, setDeleteTeam } = props
    const handleClose = () => setOpen(false);

    const DeleteTeam = async () => {
        try {
            await axios.delete(`/group/${group}`);
            loadDataGroupData()
            handleClose()
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Team deleted Successfully!',
            });
            setDeleteTeam(true)
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Team deleted Successfully!',
                });
            }, 5000);

        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Something was wrong!",
            });
        }
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
                            <p className={styles.deleteModelText}>Are you sure you want to delete</p>
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "-10px", marginBottom: "2rem" }}>
                            <p className={styles.deleteModelText}>this team?</p>
                        </Grid>
                        <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                fullWidth
                                size='large'
                                onClick={() => DeleteTeam()}
                                style={{
                                    fontSize: '0.9rem',
                                    lineHeight: '1.25rem',
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontStyle: 'normal',
                                    width: 130,
                                    height: 45,
                                    backgroundColor: "#77D0D1",
                                    color: "black",
                                    textTransform: "none",
                                }}
                            >
                                Yes,delete it
                            </Button>
                        </Grid>
                        <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                fullWidth
                                size='large'
                                onClick={() => handleClose()}
                                style={{
                                    fontSize: '0.9rem',
                                    lineHeight: '1.25rem',
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontStyle: 'normal',
                                    width: 130,
                                    height: 45,
                                    backgroundColor: "#77D0D1",
                                    color: "black",
                                    textTransform: "none",
                                }}
                            >
                                No,stay here
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}